import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { formatMetricValue } from '../utils/modeGraphicFormatters';

export default function CampaignMetricCard({ item, loading }) {
  const Icon = item.icon;

  return (
    <Box
      sx={{
        alignItems: 'center',
        background: item.background,
        border: `1px solid ${item.borderColor}`,
        borderRadius: '12px',
        boxShadow: '0 8px 18px rgba(15, 23, 42, 0.035)',
        display: 'flex',
        gap: '10px',
        minHeight: '54px',
        minWidth: 0,
        px: { xs: '11px', sm: '12px' },
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: '#FFFFFF',
          border: `1px solid ${item.borderColor}`,
          borderRadius: '10px',
          color: item.color,
          display: 'flex',
          flexShrink: 0,
          height: '30px',
          justifyContent: 'center',
          width: '30px',
        }}
      >
        <Icon sx={{ fontSize: '16px' }} />
      </Box>

      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            color: '#293142',
            fontSize: { xs: '13px', xl: '14px' },
            fontWeight: 600,
            lineHeight: 1.1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {loading ? '...' : formatMetricValue(item.value)}
        </Typography>
        <Typography
          sx={{
            color: '#8A93A4',
            fontSize: { xs: '11px', xl: '12px' },
            fontWeight: 500,
            lineHeight: 1.2,
            mt: '3px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {item.label}
        </Typography>
      </Box>
    </Box>
  );
}
